import { store } from "@store";
import { Platform } from "react-native";
import { checkNotifications } from "react-native-permissions";
import DeviceInfo from "react-native-device-info";
import { appEnv } from "@config";
import { IDFA } from "@lib/idfa";
import { postApplinkCustomEvent } from "./applinks/api";

const notificationPermission = async () => {
  try {
    const { auth } = store.getState();
    let status = null;
    if (Platform.OS === "android") {
      try {
        const { status: notificationstatus } = await checkNotifications();
        status = notificationstatus;
      } catch (e) {
        console.log(e);
      }
      const [idfa, androidId] = await Promise.all([
        IDFA.getIDFA(),
        DeviceInfo.getAndroidId(),
      ]);
      if (status !== "granted" && appEnv === "production") {
        postApplinkCustomEvent("cp-notification-permission", {
          user_id: auth?.user?.user_id,
          user_data: {
            idfa,
          },
          last_attributed_touch_data: {
            eventName: "cp-notification-permission",
            fetched_at: new Date(),
            tl_id: auth?.user?.tl_id,
            android_id: androidId,
            notificationPermissionStatus: status,
          },
        });
      }
    }
  } catch (error) {
    console.log(error);
  }
};

export default notificationPermission;
